var map = {
	"./": 318,
	"./Results.dictionaty": 341,
	"./Results.dictionaty.json": 341,
	"./Results.explanation": 1143,
	"./Results.explanation.ts": 1143,
	"./Results.module.scss": 1144,
	"./ResultsPage": 1145,
	"./ResultsPage.tsx": 1145,
	"./ResultsPageDeferred": 365,
	"./ResultsPageDeferred.tsx": 365,
	"./actions": 342,
	"./actions.ts": 342,
	"./components/Filters": 1011,
	"./components/Filters/": 1011,
	"./components/Filters/ButtonBar": 938,
	"./components/Filters/ButtonBar/": 938,
	"./components/Filters/ButtonBar/ButtonBar.module.scss": 1045,
	"./components/Filters/ButtonBar/index": 938,
	"./components/Filters/ButtonBar/index.tsx": 938,
	"./components/Filters/DatePick": 987,
	"./components/Filters/DatePick/": 987,
	"./components/Filters/DatePick/DatePick.module.scss": 1068,
	"./components/Filters/DatePick/index": 987,
	"./components/Filters/DatePick/index.tsx": 987,
	"./components/Filters/DatePick/types": 1147,
	"./components/Filters/DatePick/types.ts": 1147,
	"./components/Filters/Filter.module.scss": 1146,
	"./components/Filters/Filters.dictionary": 1072,
	"./components/Filters/Filters.dictionary.json": 1072,
	"./components/Filters/Search": 988,
	"./components/Filters/Search/": 988,
	"./components/Filters/Search/Search.dictionary": 1042,
	"./components/Filters/Search/Search.dictionary.json": 1042,
	"./components/Filters/Search/Search.module.scss": 1069,
	"./components/Filters/Search/index": 988,
	"./components/Filters/Search/index.tsx": 988,
	"./components/Filters/Sorts": 989,
	"./components/Filters/Sorts/": 989,
	"./components/Filters/Sorts/Sorts.dictionary": 1043,
	"./components/Filters/Sorts/Sorts.dictionary.json": 1043,
	"./components/Filters/Sorts/Sorts.module.scss": 1070,
	"./components/Filters/Sorts/index": 989,
	"./components/Filters/Sorts/index.tsx": 989,
	"./components/Filters/SportsList": 990,
	"./components/Filters/SportsList/": 990,
	"./components/Filters/SportsList/SportsList.module.scss": 1071,
	"./components/Filters/SportsList/index": 990,
	"./components/Filters/SportsList/index.tsx": 990,
	"./components/Filters/index": 1011,
	"./components/Filters/index.tsx": 1011,
	"./components/Tables": 992,
	"./components/Tables/": 992,
	"./components/Tables/Table": 939,
	"./components/Tables/Table/": 939,
	"./components/Tables/Table/Header": 909,
	"./components/Tables/Table/Header/": 909,
	"./components/Tables/Table/Header/Header.dictionary": 940,
	"./components/Tables/Table/Header/Header.dictionary.json": 940,
	"./components/Tables/Table/Header/Header.module.scss": 993,
	"./components/Tables/Table/Header/index": 909,
	"./components/Tables/Table/Header/index.tsx": 909,
	"./components/Tables/Table/Match": 910,
	"./components/Tables/Table/Match/": 910,
	"./components/Tables/Table/Match/Match.module.scss": 994,
	"./components/Tables/Table/Match/index": 910,
	"./components/Tables/Table/Match/index.tsx": 910,
	"./components/Tables/Table/Table.dictionary": 995,
	"./components/Tables/Table/Table.dictionary.json": 995,
	"./components/Tables/Table/Table.module.scss": 1046,
	"./components/Tables/Table/index": 939,
	"./components/Tables/Table/index.tsx": 939,
	"./components/Tables/Tables.dictionary": 1047,
	"./components/Tables/Tables.dictionary.json": 1047,
	"./components/Tables/Tables.module.scss": 1073,
	"./components/Tables/index": 992,
	"./components/Tables/index.tsx": 992,
	"./constants": 831,
	"./constants.ts": 831,
	"./index": 318,
	"./index.tsx": 318,
	"./reducer": 373,
	"./reducer.ts": 373,
	"./types": 1091,
	"./types.ts": 1091,
	"./utils/getScores": 941,
	"./utils/getScores.ts": 941,
	"./utils/sort": 991,
	"./utils/sort.ts": 991,
	"./utils/sportsList": 1044,
	"./utils/sportsList.ts": 1044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1261;
module.exports = webpackContext;